import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../Firebase/firebase";

const useLogin = (realTimeData) => {
  const navigate = useNavigate();
  // const [loginErr, setLoginErr] = useState("")

  const handleAuth = async (values, loginForm) => {
    const { email, password } = values;
    // realTimeData ? navigate("/") : navigate("auth/login");
    if (realTimeData) {
      try {
        await signInWithEmailAndPassword(auth, email, password);
        console.log(realTimeData)
        navigate("/")
      } catch (error) {
        console.log("Can't log in", error);
        // setLoginErr("User not found, can't log into your account")
        // loginForm.setFiledError("email", "no login")
      }
    } else {
      // setLoginErr("User not found, can't log into your account")
      // loginForm.setFiledError("email", "User not found, can't log into your account")
      console.log("Can't log in")
    }
  };
  // console.log(loginErr)

  return { handleAuth };
};

export default useLogin;
